import { WorkPosition } from "../models/workPosition";

let positions: WorkPosition[] = [
  {
    title: "Senior Software Engineer",
    company: "Microsoft",
    descriptions: [
      "Currently working on Copilot For Sales in React/C# with a focus on AI integration and user experience enhancements.",
      "Previously worked on Power Query Online, the ETL layer for PowerBI",
    ],
    start: "Apr 2021",
    end: "Present",
  },
  {
    title: "Senior Software Engineer",
    company: "Oracle",
    descriptions: [
      "Building out features on the DevOps Portal in React and Java",
      "Contributing to Build Service",
    ],
    start: "Dec 2019",
    end: "Apr 2021",
  },
  {
    title: "Senior Software Engineer",
    company: "Zulily",
    descriptions: [
      "Building out a CoreUX Platform in react.js",
      "Improving ci/cd - test coverage - and code sustainability",
      "Investigating and fixing bugs and working on new features",
    ],
    start: "Oct 2018",
    end: "Dec 2019",
  },
  {
    title: "Senior Software Engineer",
    company: "Microsoft",
    descriptions: [
      "Working on the Digital Crimes Unit",
      "Building tools using Microsoft Technologies to fight digital crime",
      "Investigating and fixing bugs",
    ],
    start: "Nov 2017",
    end: "Oct 2018",
  },
  {
    title: "Senior Software Engineer",
    company: "WideOrbit",
    descriptions: [
      "Designing and building internal / external features and services",
      "Using ExtJS along with C# and MSSQL",
      "Investigating and fixing bugs",
    ],
    start: "Feb 2017",
    end: "Oct 2017",
  },
  {
    title: "Senior Software Engineer",
    company: "Microsoft",
    descriptions: [
      "Participating in creative meetings with clients",
      "Building rich functional user experiences for internal and external services",
      "Investigating and fixing bugs",
    ],
    start: "Nov 2014",
    end: "Feb 2017",
  },
  {
    title: "Software Design Engineer",
    company: "Jobaline",
    descriptions: [
      "Designing and building features for internal and end users",
      "Investigating and fixing bugs",
      "Monitoring application health, performance, and traffic trends",
    ],
    start: "Jun 2013",
    end: "Oct 2014",
  },
  {
    title: "Front End Developer",
    company: "Opspire",
    descriptions: [
      "Gathering customer requirements",
      "Implementing new designs for customer applications",
      "Managing client Servers and content updates",
    ],
    start: "Jun 2011",
    end: "May 2013",
  },
  {
    title: "Technical Support",
    company: "Valve Software",
    descriptions: [
      "Investigating and helping customers resolve technical issues",
      "Analyze potentially fraudulent transactions",
      "QA work for new releases",
      "Attend Meetings to help decide what games made it onto Steam",
    ],
    start: "Nov 2010",
    end: "Sep 2011",
  },
  {
    title: "Technical Support",
    company: "Nintendo",
    descriptions: [
      "Logging into consumers computers around the world to configure their wireless routers",
      "Troubleshooting a range of technical and non-technical issues",
      "Helped discover trends in issues",
    ],
    start: "Sep 2009",
    end: "Nov 2010",
  },
  {
    title: "Systems Analyst",
    company: "Atlas Technology Group",
    descriptions: [
      "Monitor and evaluate customer server health",
      "Troubleshooting a range of technical and non-technical issues",
      "Manage client servers",
    ],
    start: "Jun 2007",
    end: "Sep 2009",
  },
];

const getPositions = (): WorkPosition[] => {
  return positions;
};

export { getPositions };
